import { FC } from "react"
import { GooeyCircleLoader } from "react-loaders-kit"
import { Props } from "./Loader.interface"

export const Loader: FC<Props> = (props) => {
  const { loading = true, ...loaderprops } = props
  return (
    <div className="m-auto flex h-full flex-grow flex-col items-center justify-center">
      <GooeyCircleLoader {...loaderprops} loading={loading} />
    </div>
  )
}
